




























import VueStrong from '@/vueStrong';
import IPin from '@/shared/interfaces/Pin';
import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { Pin } from '@/store/types';

@Component
export default class ChipView extends VueStrong {
    @Prop() private pin!: IPin;
    @Prop() private height!: number;
    @Prop() private col_id!: number;
    @Prop() private rotation!: number;

    get storePin(): Pin {
      return this.$store.state.pinout[this.pin.id];
    }

    @Inject('pin_click_handler') private pin_click_handler!: (event: Event, pin_id: number, col_id: number)=>void;
}
